import { Injectable } from '@angular/core';
import { SourceMapConsumer } from 'source-map-js';

@Injectable({ providedIn: 'root' })
export class StackTraceService {

  static instance: StackTraceService | null = null;

  constructor() {
    StackTraceService.instance = this;
  }
  async mapStackTrace(error: Error): Promise<string> {
    const stack = error.stack || '';
    const lines = stack.split('\n');
    const mappedLines: string[] = [];

    for (const line of lines) {
      const match = line.match(/(main\.js):(\d+):(\d+)/);
      if (match) {
        const [, file, lineNum, colNum] = match;
        const mapUrl = `/${file}.map`;

        try {
          const mapResponse = await fetch(mapUrl);
          const mapData = await mapResponse.json();
          const consumer = await new SourceMapConsumer(mapData);

          const originalPos = consumer.originalPositionFor({
            line: Number(lineNum),
            column: Number(colNum),
          });

          if (originalPos.source) {
            mappedLines.push(
              `${originalPos.source}:${originalPos.line}:${originalPos.column}`
            );
          } else {
            mappedLines.push(line);
          }

        //   consumer.destroy();
        } catch {
          mappedLines.push(line);
        }
      } else {
        mappedLines.push(line);
      }
    }

    return mappedLines.join('\n');
  }
}
